import moment from "moment";
import * as _ from "lodash";

export class DateHelper {
	static dateFormat = "MM/DD/YYYY";
	static dateTimeFormat = "MM/DD/YYYY hh:mm A";
	// static dateFormatGUIOnly = "dd/mm/yy";
	// static dateFormatWithDay = "D dd/mm/yy";
	// static dateTimeFormat24 = "DD/MM/YYYY HH:mm";
	// static dateTimeFormat24Us = "M/DD/YYYY HH:mm";
	static timeFormat = "HH:mm";

	static minimumDate = moment("1/1/1970", DateHelper.dateFormat).toDate();

	static formatDate(date?: Date) {
		if (!date) return "";
		return moment(date).format(DateHelper.dateFormat);
	}

	static formatDateTime(date?: Date) {
		if (!date) return "";
		// Backend stores UTC but SQL Server datetime2 strips the kind, so the
		// JSON arrives without a Z. Parse explicitly as UTC, then convert to local.
		return moment.utc(date).local().format(DateHelper.dateTimeFormat);
	}


	/*1. Together with prepareDateToShow these 2 functions allow to work with date in Timezone agnostic way. Rationale is below.
	* Being in +3GMT zone I select on holidays calendar 19. I get in my local database: Okt 2019-10-18 21:00:00.0000000 +00:00. That is 19 Okt 00:00 GMT+3.
	* If we use that in London we get wrong Holiday: 18 Okt. To fix this Dates need to be Timezone agnostic.
	* Unit test steps:
	* Input flow: Take only date. Make GMT from that. Should have 19 Okt 00:00 +OGMT Store to DB.
	* Output flow: Take from DB. Convert GMT to local. We should get 18 Okt 21:00 GMT+0 here again (or 19 Okt 00:00 GMT+3). And 19 showing on calendar in our TZ.
	* Acceptance test case: set holiday using browser in GMT+3. Inititial result: You will see the holiday in London one day shifted back. Desired result: You should see in London's browser the same day.
	* 2. This functions should be used everywhere when you work with Dates only.
	* 3. TODO: Think of how to wrap it into custom calendar control. This control should also assert if we feed non 00:00 GMT+0 dates to it.
	*/

	/* Another explanation of what we do here. We pretend that the date was selected in the browser beeing in GMT timezone. I mean physically...
	 */
	static prepareDateToStore(date?: Date | null) {
		if (!date) return date;
		const res = date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000) : date;
		return res;
	}

	// static prepareDateToStore_old(date: any) {
	//    if (!date) return null;
	//    let s1 = moment(date).format(this.dateFormat);
	//    let res = moment.utc(s1, this.dateFormat);
	//    return res.toDate();
	// }
	static prepareDateToShow(date?: Date | null) {
		if (!date) return date;
		const res = date ? new Date(date.getTime() + date.getTimezoneOffset() * 60000) : date;
		return res;
	}

	// static prepareDateToShow(date: any) {
	//    if (!date) return null;
	//    let s1 = moment(date).format(this.dateFormat);
	//    let res = moment(s1, this.dateFormat);
	//    return res.toDate();
	// }
	// Often date time gets implicitly converted to string while we need it to be Date()
	// static weekNumbers = _.range(1, 54)
	//     .map(x => <SelectItem>{ label: `${x}`, value: x });

	// static years = _.range(2021, 2050)
	//     .map(x => {
	//         const label = `${x}/${(x + 1).toString().substring(2)}`;
	//         return <SelectItem>{
	//             label: label,
	//             value: x
	//         };
	//     });

	// static yearsStrings = _.range(2021, 2050)
	//     .map(x => {
	//         const label = `${x}/${(x + 1).toString().substring(2)}`;
	//         return <SelectItem>{
	//             label: label,
	//             value: label
	//         };
	//     });

	//I suspect there might be error in logic using this value. If current month is Mar, Jan or Feb we will get wrong.
	//UPDATE: this is not first day of axial year, see requirents and Friday discussion in MS. For correct calculation see StagingTopBarComponent.
	static firstDayOfYear = new Date(new Date().getFullYear(), 3, 1);

	/*last day of March. March always have 31 day. But, beware last day of axial year is not the last day of March
	* So, wherever the field (including duplicates) is used there is an error currently.*/
	static lastDayOfYear = new Date(new Date().getFullYear() + 1, 2, 31);

	static parseAxialYearString(s: string) {
		if (!s) return null;
		const cleanYear = s.split("/")[0];
		const res = parseInt(cleanYear, 10);
		if (Number.isNaN(res)) return null;
		return res;
	}

	// static getYearAndWeekByDate(date: Date) {
	//     const curDay = moment(date);
	//     const firstAxialWeekStart = this.getAxialYearStartByDate(date, date);
	//     const days = curDay.clone().diff(firstAxialWeekStart, "day");
	//     const startYear = firstAxialWeekStart.clone().startOf("year");
	//     const finalYear = firstAxialWeekStart.clone().add(1, "year");
	//     //let yearNumber = `${startYear.year()}/${finalYear.year().toString().substring(2)}`;
	//     const yearNumber = startYear.year();
	//     const weekNumber = Math.floor(days / 7 + 1);
	//     return [yearNumber, weekNumber] as [number, number];
	// }

	// static getAxialYearStartByDate(yearTestDate: Date, referenceDate: Date) {
	//     const testDate = moment(yearTestDate);
	//     const firstApril = testDate.clone().startOf("year").add(3, "month");
	//     const firstCalendarWeekStart = firstApril.clone().startOf("week");

	//     /*We presume that Sunday is first day of calendar week. If otherwise the user will get assert.
	//     * So, to get Saturday we need to -1.
	//     * */
	//     const firstAxialWeekStart = firstCalendarWeekStart.clone().add(-1, "day");
	//     if (referenceDate >= firstAxialWeekStart.toDate()) {
	//         return firstAxialWeekStart;
	//     } else {
	//         //yeah, one step recursion
	//         return this.getAxialYearStartByDate(firstAxialWeekStart.clone().add(-1, "year").toDate(), referenceDate);
	//     }
	// }

	//Beware, there is duplicate in time-consts.ts::getWeekStart
	static getDateByYearAndWeek(axialStartYear: number, week: number, cu: any /*Cannot put CommonUtils type here because of circular dep*/) {
		if (cu) cu.assert1(true, week > 0, "week numbering should start from 1");
		const firstApril = moment(new Date(axialStartYear, 3, 1));
		const firstCalendarWeekStart = firstApril.clone().startOf("week");
		/*We presume that Sunday is first day of calendar week. If otherwise the user will get assert.
		* So, to get Saturday we need to -1.
		* */
		const firstAxialWeekStart = firstCalendarWeekStart.clone().add(-1, "day");
		const res = firstAxialWeekStart.add(week - 1, "week");
		return res.toDate();
	}

	public static localeForCalendar = {
		firstDayOfWeek: 6,
		dayNames: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
		dayNamesShort: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
		dayNamesMin: ["SU", "MO", "TU", "WE", "TH", "FR", "SA"],
		monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
		monthNamesShort: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
		today: "Today",
		clear: "Clear",
	};

	public static getMinDate(date1: Date, date2: Date) {
		if (date1 && date2) {
			return date1 > date2 ? date2 : date1;
		}
		return date1 || date2;
	}

	public static getMaxDate(date1: Date, date2: Date) {
		if (date1 && date2) {
			return date1 > date2 ? date1 : date2;
		}
		return date1 || date2;
	}
	public static addDaysToDate(date: Date, days: number) {
		let d = new Date(date);
		d.setDate(d.getDate() + days);
		return d;
	}

	/* 1. Primeng calendar has an issue when we use functions for max/min: https://github.com/primefaces/primeng/issues/4641. If function return new object than change detections considers it as change and the calendar gets re-added in the dom, this leads to double click issue. So, we need to not return new object if there is no real update of value. This is why I use memoize.
	* 2. Primeng calendar doesn't care about min/max minutes actually, only about days.
	* 3. @Memoize doesn't work on static methods for some reason (needs investigation), so, I made the method non static.
	* */
	// @Memoize((item: Date) => {
	//     return item?.toString();
	// })
	// public getNextMinute(day: Date) {
	//     if (!day) return day;
	//     return moment(day).add(1, "minute").toDate();
	// }

	// @Memoize((item: Date) => {
	//     return item?.toString();
	// })
	// public getNextDay(day: Date) {
	//     if (!day) return day;
	//     return moment(day).add(1, "day").toDate();
	// }

	// public static getMinutesFromMidnight(date: Date): number {
	//     if (!date) return null;
	//     // Your moment
	//     const mmt = moment(date);
	//     // Your moment at midnight
	//     const mmtMidnight = mmt.clone().startOf('day');
	//     // Difference in minutes
	//     const diffMinutes = mmt.diff(mmtMidnight, 'minutes');
	//     return diffMinutes;
	// }
	public static guaranteeDate<T>(holder: T, field: keyof T) {
		if (!holder[field]) return holder[field];

		(holder[field] as any as Date) = moment(holder[field]).toDate();
	}
	public static minutesToDate(minutes?: number) {
		// Remember about 0
		if (_.isNull(minutes) || _.isUndefined(minutes)) return minutes;
		return moment().clone().startOf('day').add(minutes, 'minute').toDate();
	}
	public static isMinutesValid(minutes?: number) {
		return !(_.isNull(minutes) || _.isUndefined(minutes));
	}
	public static formatMinutes(minutes?: number) {
		if (_.isNull(minutes) || _.isUndefined(minutes)) return minutes;
		let date = this.minutesToDate(minutes);
		return moment(date).format(this.timeFormat);
	}
	public static formatSeconds(seconds?: number) {
		if (_.isNull(seconds) || _.isUndefined(seconds)) return seconds;
		const hrs = Math.floor(seconds / 3600);
		const mins = Math.floor((seconds % 3600) / 60);
		const secs = Math.floor(seconds % 60);

		// Pad with zeros as needed
		const pad = (n: number) => n.toString().padStart(2, '0');
		return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
	}

	public static stripTimezoneFromIso8601(date: Date) {
		const pad = (n: any, len = 2) => String(n).padStart(len, "0");

		return (
			date.getFullYear() + "-" +
			pad(date.getMonth() + 1) + "-" +
			pad(date.getDate()) + "T" +
			pad(date.getHours()) + ":" +
			pad(date.getMinutes()) + ":" +
			pad(date.getSeconds()) + "." +
			pad(date.getMilliseconds(), 3)
		);
	}

}

